/**
 * Contacts.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BloodGroup } from '../../../../shared/common/enums/bloodGroup';
import { ContactType } from '../../../../shared/common/enums/contactType';
import { Gender } from '../../../../shared/common/enums/gender';
import { Salutation } from '../../../../shared/common/enums/salutation';
import { EmailAddressDto } from '../../../../shared/common/models/emailAddressDto';
import { MobileNumberDto } from '../../../../shared/common/models/mobileNumberDto';
import { PhoneNumberDto } from '../../../../shared/common/models/phoneNumberDto';
import { WebsiteAddressDto } from '../../../../shared/common/models/websiteAddressDto';
import { AddressDto } from './addressDto';

export class ContactDto {
    id?: string;
    type?: ContactType;
    salutation?: Salutation;
    firstName?: string;
    lastName?: string;
    organization?: string;
    designation?: string;
    department?: string;
    note?: string;
    gender?: Gender;
    avatarUri?: string;
    birthDate?: Date;
    bloodGroup?: BloodGroup;
    isLead?: boolean;
    addresses?: Array<AddressDto>;
    emails?: Array<EmailAddressDto>;
    phoneNumbers?: Array<PhoneNumberDto>;
    mobileNumbers?: Array<MobileNumberDto>;
    websites?: Array<WebsiteAddressDto>;
}
